<template>
    <div id="app">
        <m-header :params="pageParams"></m-header>
        <section class="block-wrap content-wrap">
            <!--教育服务-->
            <div class="panel-wrap">
                <m-breadcrumb :link-list="linkList"></m-breadcrumb>

                <div class="block-content">
                    <div class="block-main mt20">
                        <div class="job-info">
                            <div>
                                <p class="main-font">{{ pageData.job.jobName }}</p>
                                <p class="mt10">
                                    <span class="tip-font">点击次数：{{ pageData.job.viewCount }}</span>
                                </p>
                                <p class="mt20">
                                    <span class="tip-font">岗位福利：</span>
                                    <el-tag class="tag-item" v-for="item in pageData.job.welfare" size="mini" :key="item"
                                        type="info" effect="plain">{{ item }}
                                    </el-tag>
                                </p>
                            </div>
                            <div style="text-align: right">
                                <p class="info-salary-font">{{ pageData.job.minSalary }}K-{{ pageData.job.maxSalary }}K/月
                                </p>
                            </div>
                        </div>
                        <div class="main-tit-col">发布院校</div>
                        <div class="main-info-col">
                            <div class="main-info-body">
                                <div class="main-info-li" v-for="item of schoolData" :key="item.id"
                                    @click="applyJob(item.schoolName,item.sourceWebUrl)">
                                    <img v-real-img="item.schoolLogo" default-img="imgs/default/logo.png" alt="">
                                    <b>{{ item.schoolName }}</b>
                                    <p>发布时间：{{ item.publishTime }}</p>
                                    <div class="hoverShow">
                                        <b>点击进入就业网</b>
                                        <span></span>
                                        <b>进行投递</b>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="main-tit-col">岗位描述</div>
                        <div class="main-info-col">
                            <section v-html="pageData.job.jobDescribe"></section>
                        </div>

                        <div class="main-tit-col">单位简介</div>
                        <div class="main-info-col">
                            <section v-html="pageData.company.describe"></section>
                        </div>

                    </div>
                    <div class="block-sidebar">
                        <div class="sidebar-header">
                            <div class="sidebar-logo">
                                <img v-real-img="pageData.company.logo" default-img="imgs/default/logo.png" alt="">
                            </div>
                            <p class="main-font sidebar-tit">{{ pageData.company.name }}</p>
                        </div>

                        <div class="sidebar-body mt20">
                            <p class="tip-font sidebar-tip"><span class="tip-label">行业：</span><span>{{
                                pageData.company.industry }}</span>
                            </p>
                            <p class="tip-font sidebar-tip"><span class="tip-label">规模：</span><span>{{
                                pageData.company.scale }}</span>
                            </p>
                            <p class="tip-font sidebar-tip"><span class="tip-label">地址：</span><span>{{
                                pageData.company.address }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <m-footer></m-footer>
    </div>
</template>
<script>
import mFooter from "@/components/mFooter";
import mHeader from "@/components/mHeader";
import mBreadcrumb from "@/components/mBreadcrumb";
import moment from "moment";

export default {
    name: 'mNotice',
    data() {
        return {
            pageState: {
                panelMenuIndex: 0
            },
            pageParams: {
                menuIndex: '/jobfair.html',
                // swipeHeight: '500px',
            },
            pageData: {
                schoolName: '长沙理工大学',
                job: {
                    // companyId: 1,
                    // jobName: '销售总监/经理',
                    // viewCount: '1820',
                    // applyState: false,
                    // salary: '14K-18K/月',
                    // publishTime: '2022-11-11 00:00:00',
                    // welfare: ['五险一金', '绩效奖金', '岗前培训'],
                    // jobDescript: '湖南华创地产集团有限公司是一家以商业地产投资为主，集商业、住宅地产开发、高端酒店投资、商业运营、建筑施工、装饰设计和物业管理为一体的综合性、跨区域的大型民营企业。2013-2015年，国务院发展研究中心、清华大学房地产研究所和中国指数研究院组织中国房地产百强企业年度评审。湖南华创地产集团连续三年入选“中国商业地产30强”。历经21载，项目分布湖南、湖北、河南、河北，为多个城市创造全新商业地标。\n',
                },
                company: {
                    // logo: "https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/company/1510366378-9293.jpg@128w_128h_4e",
                    // address: "湖南长沙宁乡高新区亚洲北路100号",
                    // name: "湖南华创地产集团有限公司",
                    // industry: "制造业",
                    // scale: "500-1000人",
                    // tel: "0731-12345678",
                    // email: "1213456789@qq.com",
                    // describe: '湖南华创地产集团有限公司 [1]  是在1998年成立的中方建筑工程有限公司基础上发展壮大起来的，公司总部位于湖南省长沙市，净资产逾三十亿元，拥有房产开发及建筑施工总承包资质。现有员工2000余人，其中80%以上拥有大专以上学历。公司旗下企业共有九家，分别为：长沙市华创房地产开发有限公司、保定市华创房地产开发有限公司、三门峡市华创房地产开发有限公司、洛阳市强人房地产开发有限公司、襄阳市强人房地产开发有限公司、灵宝市强人房地产开发有限公司、宜阳华创房地产开发有限公司、中方建筑工程有限公司、百盛达商业管理有限公司。',
                },
            },
            schoolData: {}
        }
    },
    computed: {
        linkList() {
            return [
                { "title": '岗位信息', "link": 'jobs.html' },
                { "title": '正文', 'link': "" }
            ]
        }
    },
    components: {
        mFooter, mHeader, mBreadcrumb
    },
    methods: {
        dateFormat(date, format) {
            return moment(date).format(format);
        },
        getDetail(id, isSchoolJob) {
            this.$api.getJobDetail({ id, isSchoolJob: isSchoolJob }).then(
                data => {
                    this.pageData = data;
                    this.getPublishSchoolList(this.pageData.job.id);
                }
            )
        },
        //获取职位发布院校
        getPublishSchoolList(id) {
            this.$api.getPublishSchoolList({ jobId:id }).then(
                data => {
                    this.schoolData = data;
                }
            )
        },
        applyJob(source, url) {
            if (url) {
                this.$util.showLevelDialog(this, source, url)
            } else {
                window.location.href = 'http://student.hunbys.net'
            }
        },
        goDetail(type, id) {
            this.$util.goDetail(type, id);
        },
        //链接跳转
        gotoUrl(item) {
            if (item) {
                window.open(item);
            }
        },
    },
    created() {
        let id = this.$util.getQueryString("id");
        let isSchoolJob = this.$util.getQueryString("isSchoolJob") || false;
        this.getDetail(id, isSchoolJob);
    }
}
</script>
<style lang="scss" scoped>
@import "@/common/sass/common.scss";

.content-wrap {
    width: 1400px;
    margin: 0 auto;
    overflow: hidden;
}

.panel-wrap {
    margin-top: 30px;
    background-color: #ffffff;

    .block-content {
        display: flex;
        width: 100%;
        justify-content: space-between;

        .block-main {
            width: 1120px;

            .job-info {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 40px;

                .main-font {
                    font-size: 24px;
                }

                .info-salary-font {
                    font-size: 20px;
                    font-weight: bold;
                }

                .tag-item {
                    margin-right: 10px;
                }
            }

            .main-tit-col {
                margin-top: 10px;
                height: 50px;
                line-height: 50px;
                background-color: #F4F7FC;
                padding: 0 20px;

                font-size: 16px;
                font-weight: bold;
                color: #333333;
                box-sizing: border-box;
                background-image: url("../../../public/imgs/col-bg.png");
                background-position: left top;
                background-size: 11px 11px;
                background-repeat: no-repeat;
            }

            .main-info-col {
                padding: 20px;
                background-color: #ffffff;
                font-size: 15px;
                color: #555555;
                line-height: 28px;

                &>section {
                    text-indent: 30px;
                }

                .main-info-body {
                    display: flex;
                    justify-content: start;
                    align-items: center;
                    flex-wrap: wrap;

                    .main-info-li {
                        position: relative;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        justify-content: end;
                        align-items: center;
                        width: 23%;
                        height: 48%;
                        margin: 1% 1%;
                        border: .1px solid rgb(216, 216, 216);
                        border-radius: 6px;
                        overflow: hidden;

                        img {
                            width: auto;
                            height: auto;
                            max-width: 100%;
                            max-height: 100px;
                        }

                        p {
                            font-size: 13px;
                            color: gray;
                        }

                        .hoverShow {
                            position: absolute;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            color: #fff;
                            font-size: 17px;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(27, 97, 202, 0.8);
                            opacity: 0;

                            span {
                                width: 15%;
                                height: 4px;
                                background-color: #cfc42c;
                                border-radius: 2px;
                            }
                        }
                    }

                    .main-info-li:hover {
                        .hoverShow {
                            opacity: 1;
                        }
                    }
                }

            }
        }

        .block-sidebar {
            width: 240px;
            height: 450px;
            background: #F4F7FC;
        }
    }

    .block-sidebar {
        padding: 25px;
        box-sizing: border-box;
        min-height: 450px;

        .sidebar-header {
            text-align: center;
            border-bottom: 1px solid #ffffff;

            .sidebar-tit {
                font-size: 15px;
                margin: 15px 0 20px;
            }


            .sidebar-logo {
                width: 80px;
                height: 80px;
                background: #FFFFFF;
                border: 2px solid #F3F3F3;
                border-radius: 2px;
                overflow: hidden;
                margin: 0 auto;
                line-height: 80px;

                img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100px;
                }
            }
        }

        .sidebar-tip {
            color: #666666;
            margin-top: 10px;

            display: flex;

            .tip-label {
                width: 45px;
                flex-shrink: 0;
            }
        }
    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px dashed #E9E8E8;
        ;
    }

    .el-table::before {
        content: none;
    }

}
</style>